import React from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalFormGroup,
    StandardModalInput,
    StandardModalLabel,
    StandardModalSection,
    StandardModalSectionTitle,
    StandardModalSelect
} from "./StandardModal";
import { portalColors, SegmentedButtonGroup } from "./BusinessPortalComponents";

export function TaxonomyEditorModal({
    open,
    onClose,
    title,
    description,
    nameLabel,
    name,
    onNameChange,
    nameError,
    visibilityOptions,
    visibleTo,
    onVisibleToChange,
    categories,
    selectedCategory,
    onCategoryChange,
    categoryError,
    onSubmit,
    isLoading,
    onDelete,
    children
}) {
    return (
        <StandardModal
            open={open}
            onClose={onClose}
            title={title}
            description={description}
            widthMode="medium"
            footer={(
                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "0.75rem" }}>
                    {onDelete ? <StandardModalActionButton $variant="danger" width="12rem" onClick={onDelete}>Delete</StandardModalActionButton> : <div />}
                    <StandardModalActionGroup $pushRight>
                        <StandardModalActionButton disabled={isLoading} onClick={onClose}>Cancel</StandardModalActionButton>
                        <StandardModalActionButton $variant="primary" disabled={isLoading} onClick={onSubmit}>Save</StandardModalActionButton>
                    </StandardModalActionGroup>
                </div>
            )}
        >
            <StandardModalSection background={portalColors.surfaceSoft}>
                <StandardModalFormGroup>
                    <StandardModalLabel>{nameLabel}</StandardModalLabel>
                    <StandardModalInput value={name} onChange={onNameChange} maxLength={100} background={portalColors.surface} />
                    {nameError && <StandardModalDescription color="#D64545">{nameError}</StandardModalDescription>}
                </StandardModalFormGroup>
            </StandardModalSection>

            {children}

            <StandardModalSection>
                <StandardModalSectionTitle>Visible To</StandardModalSectionTitle>
                <SegmentedButtonGroup
                    options={visibilityOptions}
                    value={visibleTo}
                    equalWidth
                    onChange={onVisibleToChange}
                />
            </StandardModalSection>

            {categories && (
                <StandardModalSection>
                    <StandardModalFormGroup>
                        <StandardModalLabel>Select Category</StandardModalLabel>
                        <StandardModalSelect value={selectedCategory} onChange={onCategoryChange} width="min(100%, 20rem)">
                            <option value="category">Please select a category</option>
                            {categories.map(category => <option key={category.uuid} value={category.uuid}>{category.name}</option>)}
                        </StandardModalSelect>
                        {categoryError && <StandardModalDescription color="#D64545">{categoryError}</StandardModalDescription>}
                    </StandardModalFormGroup>
                </StandardModalSection>
            )}
        </StandardModal>
    );
}
